import { render, staticRenderFns } from "./CreateExtra.vue?vue&type=template&id=34412118"
import script from "./CreateExtra.vue?vue&type=script&lang=ts"
export * from "./CreateExtra.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports